import dayjs from "dayjs"

import { ONBOARDING_STORAGE_KEY } from "@mobile/components/Tutorials/HomeOnboardingTour/constants"
import { VisitorStatus } from "@mobile/screens/Home/components/VisitorsWidget/utils"
import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export type VisitorsExportFilters = {
  params: Record<string, string>
  status: VisitorStatus | ""
}

type MobileAppState = {
  selectedDay: string
  isBookingSheetOpen: boolean
  hasMadeInitialBookingDecision: boolean
  isOnboardingCompleted: boolean
  visitorsExportFilters: VisitorsExportFilters | null
}

/**
 * Mirrored into the store so surfaces outside the Home screen (the default
 * floor nudge) can react when the Joyride tour finishes; localStorage alone
 * does not notify same-tab subscribers.
 */
const initialState: MobileAppState = {
  selectedDay: dayjs().startOf("day").toISOString(),
  isBookingSheetOpen: false,
  hasMadeInitialBookingDecision: false,
  isOnboardingCompleted:
    window.localStorage.getItem(ONBOARDING_STORAGE_KEY) === "true",
  visitorsExportFilters: null,
}

const mobileAppSlice = createSlice({
  name: "mobileApp",
  initialState,
  reducers: {
    setSelectedDay: (state, { payload }: PayloadAction<string>) => {
      state.selectedDay = payload
    },
    setIsBookingSheetOpen: (state, { payload }: PayloadAction<boolean>) => {
      state.isBookingSheetOpen = payload
    },
    markInitialBookingDecisionMade: (state) => {
      state.hasMadeInitialBookingDecision = true
    },
    markOnboardingCompleted: (state) => {
      state.isOnboardingCompleted = true
    },
    setVisitorsExportFilters: (
      state,
      { payload }: PayloadAction<VisitorsExportFilters | null>,
    ) => {
      state.visitorsExportFilters = payload
    },
  },
})

export const mobileAppReducer = mobileAppSlice.reducer
export const {
  setSelectedDay,
  setIsBookingSheetOpen,
  markInitialBookingDecisionMade,
  markOnboardingCompleted,
  setVisitorsExportFilters,
} = mobileAppSlice.actions
